const SELECT_ALL_DROPDOWN_KEYS_ID = "select_all_keys";

export const getDropdownIds = (
    competitors: string[] | number[],
    selectedKeys: string[] | number[],
    isAllKeysSelected: boolean,
    customAllSelectedKey?: string | number,
): { [key: string | number]: boolean } =>
    competitors?.length
        ? competitors.reduce((acc, curr) => ({ ...acc, [curr]: selectedKeys.includes(curr as never) }), {
              [customAllSelectedKey ? customAllSelectedKey : SELECT_ALL_DROPDOWN_KEYS_ID]: isAllKeysSelected,
          })
        : {};
